import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Fragment, Component } from 'react';
import { omit } from '../../utils';
import UIButton from 'UIComponents/button/UIButton';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import ProductActivationWrapper from 'ui-addon-upgrades/_core/productActivation/ProductActivationWrapper';
import { activateProduct } from 'ui-addon-upgrades/_core/productActivation/activateProduct';
import ActivationModalContainer from 'ui-addon-upgrades/_core/common/components/activation/ActivationModalContainer';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';

class ProductActivationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProductActivationModal: false,
      hasActivationError: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {
      upgradeData
    } = this.props;
    tracker.track('productActivationButtonInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData)));
  }

  handleClick() {
    const {
      upgradeData,
      canViewNewSeats
    } = this.props;
    tracker.track('productActivationButtonInteraction', Object.assign({
      action: 'clicked'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    activateProduct(upgradeData, canViewNewSeats).then(() => this.setState({
      showProductActivationModal: true
    })).catch(() => this.setState({
      showProductActivationModal: true,
      hasActivationError: true
    }));
  }

  renderButton() {
    const {
      upgradeData,
      canViewNewSeats
    } = this.props;
    const propsToPass = omit(this.props, ['onClick', 'upgradeData', 'onSuccess', 'allowModal']);
    return /*#__PURE__*/_jsx(UIButton, Object.assign({}, propsToPass, {
      "data-reagan-primary-cta": true,
      onClick: this.handleClick,
      "data-test-id": "product-activation-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: canViewNewSeats && upgradeData.apiName ? `upgrades.productActivationButton.${upgradeData.apiName}` : `upgrades.productActivationButton.${upgradeData.upgradeProduct}`
      })
    }));
  }

  render() {
    const {
      showProductActivationModal,
      hasActivationError
    } = this.state;
    const {
      onSuccess,
      upgradeData
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [showProductActivationModal && /*#__PURE__*/_jsx(ActivationModalContainer, {
        type: sourceKeys.PRODUCT_ACTIVATION,
        onSuccess: onSuccess,
        hasError: hasActivationError,
        upgradeData: upgradeData
      }), this.renderButton()]
    });
  }

}

ProductActivationButton.defaultProps = {
  use: 'primary'
}; // @ts-expect-error type is too long

ProductActivationButton.propTypes = Object.assign({}, upgradeDataPropsInterface, {
  onSuccess: PropTypes.func
});
export default ProductActivationWrapper(ProductActivationButton);